/* ======================================================================
   МОДУЛЬ СИНХРОНИЗАЦИИ ПРОФИЛЯ, TELEGRAM BACK BUTTON И АВТО-РЕГИСТРАЦИИ
   ====================================================================== */

function initTelegramBackButton() {
  const tg = window.Telegram?.WebApp;
  if (!tg?.BackButton) return;

  if (tgBackHandler) {
    try { tg.BackButton.offClick(tgBackHandler); } catch (e) {}
    tgBackHandler = null;
  }

  const hasOpenModal = document.querySelector('[class*="-backdrop"].is-open');
  const path = window.location.pathname;
  const isDashboard = path.endsWith('dashboard.html') || path.endsWith('dashboard');
  const isHome = path === '/' || path.endsWith('landing.html') || path.endsWith('index.html') || isDashboard;

  if (hasOpenModal) {
    try { tg.BackButton.show(); } catch (e) {}
    tgBackHandler = () => {
      triggerHaptic('light');
      closeAnyOpenModal();
      onModalStateChanged();
    };
    tg.BackButton.onClick(tgBackHandler);
    return;
  }

  if (isHome) {
    try { tg.BackButton.hide(); } catch (e) {}
  } else {
    try {
      tg.BackButton.show();
      tgBackHandler = () => {
        triggerHaptic('light');
        if (typeof spaNavigate === 'function') {
          spaNavigate('/dashboard.html' + (window.location.search || ''));
        } else {
          window.location.href = '/dashboard.html' + (window.location.search || '');
        }
      };
      tg.BackButton.onClick(tgBackHandler);
    } catch (e) {}
  }
}

// Фоновая синхронизация профиля участника с сервером (Telegram WebApp / внешний браузер)
async function syncProfileWithServer() {
  const tgUser = window.Telegram?.WebApp?.initDataUnsafe?.user;
  const localUser = getUser();
  const p = new URLSearchParams(window.location.search);
  const hp = new URLSearchParams((window.location.hash || '').replace(/^#/, ''));

  const queryTgId = p.get('telegram_id') || hp.get('telegram_id') || null;
  const queryUserId = p.get('user_id') || hp.get('user_id') || null;

  const tgId = (tgUser?.id ? String(tgUser.id) : null) || queryTgId || localUser?.telegramId || localStorage.getItem('meta_tg_user_id') || null;

  // Реферальные параметры сохраняем исключительно как реферера, но НЕ как авторизованного пользователя
  const refParam = p.get('ref') || p.get('startapp') || hp.get('ref') || hp.get('startapp');
  if (refParam) {
    const cleanRef = String(refParam).replace(/^ref_/, '');
    if (cleanRef && cleanRef !== tgId) {
      localStorage.setItem('meta_referrer_id', cleanRef);
    }
  }

  // Идентификация строго текущего пользователя (защита от Session Bleeding и угона сессии)
  const cookieUserId = typeof getSessionCookie === 'function' ? getSessionCookie('meta_user_id') : null;
  const targetId = tgId || (localUser?.id || null) || queryUserId || cookieUserId;
  if (!targetId) return null;

  try {
    const res = await fetch(`/api/user/${encodeURIComponent(targetId)}?t=${Date.now()}`, {
      headers: {
        'X-Telegram-User-Id': tgId ? String(tgId) : ''
      }
    });
    if (res.status === 404) {
      // Если профиль не найден по ID, но локально есть Telegram username — пробуем восстановить аккаунт по юзернейму
      const cleanUser = (localUser?.username || localUser?.telegram_username || localUser?.telegramUsername || '').replace(/^@/, '').trim();
      if (cleanUser && targetId !== cleanUser) {
        try {
          const res2 = await fetch(`/api/user/${encodeURIComponent(cleanUser)}?t=${Date.now()}`);
          if (res2.ok) {
            const data2 = await res2.json();
            if (data2.ok && data2.user) {
              const u2 = data2.user;
              localStorage.setItem(STORAGE_KEY, JSON.stringify(u2));
              localStorage.setItem(REGISTERED_FLAG, 'true');
              if (u2.id) localStorage.setItem('meta_user_id', u2.id);
              if (u2.telegram_id) localStorage.setItem('meta_tg_user_id', String(u2.telegram_id));
              if (u2.channel_subscribed === 1 || u2.channel_subscribed === true) {
                localStorage.setItem('meta_channel_subscribed', 'true');
                localStorage.setItem('meta_unlocked_days', JSON.stringify([1, 2, 3, 4]));
              }
              inMemoryUser = u2;
              window.__metaUser = u2;
              updateLandingCTA();
              updateHeaderNav();
              return u2;
            }
          }
        } catch (e2) {}
      }

      // Если восстановить не удалось — очищаем невалидный ghost ID
      localStorage.removeItem(REGISTERED_FLAG);
      localStorage.removeItem(STORAGE_KEY);
      localStorage.removeItem('meta_user_id');
      inMemoryUser = null;
      window.__metaUser = null;
      updateLandingCTA();
      updateHeaderNav();
      return null;
    }
    if (res.ok) {
      const data = await res.json();
      if (data.ok && data.user) {
        const u = data.user;
        if (u.telegram_id) {
          localStorage.setItem('meta_tg_user_id', String(u.telegram_id));
        }
        if (u.channel_subscribed === 1 || u.channel_subscribed === true || u.channel_subscribed === 'true' || u.channel_subscribed === '1') {
          localStorage.setItem('meta_channel_subscribed', 'true');
          localStorage.setItem(STORAGE_UNLOCKED_DAYS, JSON.stringify([1, 2, 3, 4]));
        }
        if (u.unlocked_days) {
          try {
            const days = typeof u.unlocked_days === 'string' ? JSON.parse(u.unlocked_days) : u.unlocked_days;
            if (Array.isArray(days)) {
              localStorage.setItem(STORAGE_UNLOCKED_DAYS, JSON.stringify(days));
              if (days.includes(2)) localStorage.setItem('meta_paid_day_2', 'true');
              if (days.includes(3)) localStorage.setItem('meta_paid_day_3', 'true');
              if (days.includes(4)) localStorage.setItem('meta_paid_day_4', 'true');
            }
          } catch (err) {}
        }
        if (u.has_paid) {
          localStorage.setItem('meta_paid_all_days', 'true');
          [2, 3, 4].forEach(d => unlockDayLocally(d));
        }
        if (u.completed_days && typeof u.completed_days === 'object') {
          Object.entries(u.completed_days).forEach(([d, compAt]) => {
            localStorage.setItem(`meta_day_${d}_completed`, 'true');
            if (!localStorage.getItem(`meta_day_${d}_completed_at`) && compAt) {
              localStorage.setItem(`meta_day_${d}_completed_at`, String(compAt));
            }
          });
        }
        if (typeof u.referral_count === 'number') {
          localStorage.setItem(STORAGE_REF_COUNT, String(u.referral_count));
        }
        if (typeof u.bonus_balance === 'number') {
          localStorage.setItem(STORAGE_BONUS_BALANCE, String(u.bonus_balance));
        }
        if (Array.isArray(u.invited_friends)) {
          localStorage.setItem(STORAGE_INVITED_FRIENDS, JSON.stringify(u.invited_friends));
        }
        if (u.name || u.phone || u.id) {
          const current = getUser() || {};
          current.id = u.id || current.id;
          current.name = u.name || current.name;
          current.phone = u.phone || current.phone;
          current.email = u.email || current.email;
          current.telegramId = u.telegram_id || current.telegramId;
          current.telegram_id = u.telegram_id || current.telegram_id;
          current.channel_subscribed = u.channel_subscribed ?? current.channel_subscribed;
          current.platform = u.platform || current.platform;
          current.bonus = u.bonus_balance || current.bonus;
          current.has_paid = Boolean(u.has_paid);
          current.hasPaid = Boolean(u.has_paid);
          current.unlocked_days = u.unlocked_days;
          current.day_unlock_timers = u.day_unlock_timers || current.day_unlock_timers;
          current.completed_days = u.completed_days || current.completed_days;
          current.registered_at = u.registered_at || current.registered_at;
          current.registered = true;
          inMemoryUser = current;
          window.__metaUser = current;
          window.__metaDrip = {
            next_unlock_day: u.next_unlock_day,
            next_unlock_seconds: u.next_unlock_seconds,
            day_unlock_timers: u.day_unlock_timers
          };
          try {
            localStorage.setItem(STORAGE_KEY, JSON.stringify(current));
            localStorage.setItem(REGISTERED_FLAG, 'true');
            if (typeof setSessionCookie === 'function') {
              if (current.id) setSessionCookie('meta_user_id', current.id);
              setSessionCookie('meta_user_registered', 'true');
            }
            if (u.has_paid) {
              localStorage.setItem('meta_paid_all_days', 'true');
              localStorage.setItem('meta_paid_day_2', 'true');
              localStorage.setItem('meta_paid_day_3', 'true');
              localStorage.setItem('meta_paid_day_4', 'true');
              localStorage.setItem(STORAGE_UNLOCKED_DAYS, JSON.stringify([1, 2, 3, 4]));
            }
          } catch (err) {}
        }
        updateLandingCTA();
        updateHeaderNav();
        updateBonusUI();
        updateReferralUI();
        updateDayPageUI();
        if (window.location.pathname.includes('dashboard.html') || window.location.pathname.includes('dashboard')) {
          updateDashboardUI(getUser());
          if (typeof updateDashboardDaysUI === 'function') {
            updateDashboardDaysUI();
          }
        }
        document.documentElement.classList.remove('meta-auth-checking');
        return data;
      }
    }
  } catch (e) {
    // Offline fallback
  }
  return null;
}

let autoRegisterTriggered = false;
function checkAndTriggerAutoRegister(force = false) {
  if (autoRegisterTriggered && !force) return;
  if (isRegistered()) return;

  const currentPath = window.location.pathname;
  const isProtected = currentPath.endsWith('dashboard.html') || currentPath.endsWith('dashboard') || currentPath.includes('day-') || currentPath.endsWith('referral.html') || currentPath.endsWith('questionnaire.html');

  const urlParams = new URLSearchParams(window.location.search);
  const hasParam = urlParams.get('auto_register') === '1' || urlParams.get('open_register') === '1';

  // Если пользователь закрыл модалку на этой сессии, не спамим таймерами, если нет явного force/param/protected
  if (!force && !hasParam && !isProtected && sessionStorage.getItem('meta_reg_modal_dismissed') === 'true') {
    return;
  }

  // При первом заходе на сайт модалка НЕ открывается автоматически; только по клику на кнопку или при переходе на защищенную страницу
  if (isProtected || hasParam || force) {
    autoRegisterTriggered = true;
    if (hasParam) {
      try {
        const cleanParams = new URLSearchParams(window.location.search);
        cleanParams.delete('auto_register');
        cleanParams.delete('open_register');
        const cleanSearch = cleanParams.toString() ? '?' + cleanParams.toString() : '';
        const cleanUrl = window.location.pathname + cleanSearch + window.location.hash;
        window.history.replaceState({}, '', cleanUrl);
      } catch (e) {}
    }

    const destUrl = isProtected ? (window.location.pathname + (window.location.search || '')) : ('/dashboard.html' + (window.location.search || ''));
    setTimeout(() => {
      if (!isRegistered() && typeof openModal === 'function') {
        openModal(destUrl);
      }
    }, 400);
  }
}

window.initTelegramBackButton = initTelegramBackButton;
window.syncProfileWithServer = syncProfileWithServer;
window.checkAndTriggerAutoRegister = checkAndTriggerAutoRegister;